import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectGeneralProject } from "../../../redux/selectors";
import { useEffect, useState } from "react";

function formatDate(dateString) {
  if (!dateString) return "";
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

function PrintHeader({ generatedAt }) {
  const storedJobDetails = useSelector(selectGeneralProject);

  const [jobDetails, setJobDetails] = useState({});

  useEffect(() => {
    if (storedJobDetails.length > 0) {
      setJobDetails(storedJobDetails[0]);
    }
  }, [storedJobDetails]);

  return (
    <div>
      {jobDetails ? (
        <div className="flex-fill m-3">
          <Row>
            <Col className="text-center">
              <strong>
                {jobDetails.JobNumber} | {jobDetails.ProjectName}
              </strong>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">{jobDetails.ModelNumber}</Col>
          </Row>
          <Row>
            <Col className="text-center">
              <strong>Project Manager:</strong> {jobDetails.ProjectManager} |{" "}
              <strong>Sales Rep:</strong> {jobDetails.SalesRep}
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <strong>Order Date:</strong> {formatDate(jobDetails.OrderDate)} |{" "}
              <strong>Requested Delivery Date:</strong> {formatDate(jobDetails.RequestedDeliveryDate)}
            </Col>
          </Row>
          {generatedAt && (
            <Row>
              <Col className="text-center text-muted small">
                <strong>Exported:</strong> {generatedAt}
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <p>No job details found.</p>
      )}
    </div>
  );
}

export default PrintHeader;
